import styled from "styled-components";

export default styled.div`

#title{
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
  text-align: center;
  align-content: center;
  gap: ${props => props.theme.spacing.spacing_04};
  margin-bottom: ${props => props.theme.spacing.spacing_04};
}

h4{
  display:flex;
  align-items: center;
  justify-content: center;
}
/* 
td, th{
  vertical-align: middle !important;
  border-left: none;
}

tbody tr{
  border-left: none;
  cursor: pointer;
} */

.icon {
  width: ${props => props.theme.spacing.spacing_08};
  height:  ${props => props.theme.spacing.spacing_06};
}

.custom-modal{
  font-size: 24px;
  background-color: ${props => props.theme.colors.primary};
}

`